module.exports = __webpack_public_path__ + "static/media/bpcl_color.299c4e0d.jpg";